import React, { useCallback, useEffect } from 'react'
import RoomCard from '@/components/Room/RoomCard'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { getRoomDetails, getRoomMembers } from '@/redux/asyncThunks/room'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { CardType, Status } from '@/redux/types/room'
import ROUTES from '@/routes/routes'
import { fetchTeamsByRoomId } from '@/redux/asyncThunks/team'

const TeamChats: React.FC = () => {
  const dispatch = useAppDispatch()
  const params = useParams()
  const roomId = params.roomId as string
  const navigate = useNavigate()
  const { teams } = useAppSelector((state) => state.team)
  const { roomMembers, currentRoom } = useSelector(
    (state: RootState) => state.room
  )

  useEffect(() => {
    if (roomId) {
      dispatch(getRoomMembers(roomId))
      dispatch(fetchTeamsByRoomId(roomId))
    }
  }, [roomId])

  const handleRefresh = useCallback(() => {
    if (currentRoom?.roomid) {
      dispatch(getRoomDetails(currentRoom.roomid))
    }
  }, [dispatch, currentRoom?.roomid])

  const handleJoinTeamChat = (teamId: string) => {
    if (currentRoom?.roomid && currentRoom?.invite_code) {
      navigate(
        ROUTES.PROFESSOR.GAME(currentRoom.roomid, {
          teamId: teamId,
          inviteCode: currentRoom.invite_code,
          panel: 'chat',
        })
      )
    }
  }

  return (
    <div>
      <div className='flex gap-2 items-center mt-8'>
        <h5 className='text-xl font-bold text-dark-blue'>Team Chats</h5>
        <div
          onClick={handleRefresh}
          className='p-1 bg-transparent rounded-md cursor-pointer'
        >
          <img src='/icons/refresh.svg' alt='Refresh' className='size-5' />
        </div>
      </div>
      <p className='text-lg text-dark-blue'>Monitor team chat(s).</p>
      {teams.length > 0 ? (
        <div className='grid grid-cols-[repeat(auto-fill,_minmax(224px,_1fr))] xl:grid-cols-5 gap-9 mt-11'>
          {teams.map((team) => {
            const teamMembersCount = roomMembers.filter(
              (member) => member.teamId === team.id
            ).length
            return (
              <RoomCard
                cardType={CardType.NEGOTIATION}
                key={team.id}
                roomId={team.name}
                buttonText='View Team Chat'
                roomIdPrefix='Team:'
                onButtonClick={() => handleJoinTeamChat(team.id.toString())}
                showBadge={true}
                status={Status.Accepted}
                isProfessor={true}
                advisorsCount={currentRoom?.advisors_count}
                pendingAdjudicationsCount={0}
                playersCount={teamMembersCount}
              />
            )
          })}
        </div>
      ) : (
        <div className='h-[15.6rem] flex justify-center items-center flex-col gap-2 mt-11'>
          <img
            src='/icons/no-negotiation.svg'
            alt='No Sessions'
            className='w-40 h-40'
          />
          <p className='text-lg text-dark-blue'>No Negotiation Sessions</p>
        </div>
      )}
    </div>
  )
}

export default TeamChats
